module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/7EdwGf/tc-custom/9781118046760.jpg?1728725488486",
      "alt": "This image is the cover for the book Advanced Facilitation Strategies"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Advanced Facilitation Strategies\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("From Ingrid Bens, the author of the best-selling book  Facilitating with Ease!, comes the next-step resource for  project leaders, managers, community leaders, teachers, and other  facilitators who want to hone their skills in order to deal with  complex situations. Advanced Facilitation Strategies is a  field guide that offers practical strategies and techniques for  working with challenging everyday situations. These proven  strategies and techniques are based on experience gleaned from  hundreds of facilitated activities in organizations of all sizes  and in all sectors.   Both novice and seasoned facilitators who have had firsthand  experience designing and leading meetings will benefit from this  reality-based playbook. Advanced Facilitation Strategies is  filled with the information facilitators need to    Become better at diagnosing facilitation assignments and  creating effective process designs  Broaden their repertoire of tools to make impromptu design  changes whenever they are needed  Learn to be more resilient and confident when dealing with  dysfunctional situations and difficult people.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ingrid Bens\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Ingrid Bens is a consultant, speaker, and trainer who specializes in facilitation skills, team building, conflict management, employee participation, and organizational change. She is a partner in the consulting firm Participative Dynamics.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    John Wiley & Sons\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0